import React, { useEffect, useState } from 'react';
import { useAllAccounts, useUserAccount } from '../hooks/useAccount';
import { useUser } from '../hooks/useUser';
import { Account } from '../sp-types/accountTypes';
import { useAccountStore } from './Stores/accountStore';
import { useAdminModeStore } from './Stores/EditAdminStore';
import ButtonDesigned from './UI-Elements/Buttons/ButtonDesigned';

const AccountSelector = () => {
  // Relevant For Admin Mode
  const [companyNames, setCompanyNames] = useState<any[]>([]);
  const { setAccount, setHasAccount, setIsAccountLoading } = useAccountStore();
  let idToCompanyNameMap = {};
  const { isAdmin, setIsAdmin, isAdminMode, setIsAdminMode } = useAdminModeStore();
  const { data: userData } = useUser();
  const { data: accountData, isLoading: isAccountDataLoading } = useUserAccount(!isAdminMode);

  //Updates account store
  useEffect(() => {
    if (accountData?.account) {
      setAccount(accountData.account);
      setHasAccount(true);
    }
  }, [accountData]);

  // in Case Of Admin Mode Fetch All accounts
  const {
    data: accountsListData,
    error: accountsDataListError,
    isLoading: isAccountsDataLoading,
  } = useAllAccounts(isAdminMode);

  // Not Admin Mode - Fetch account by user

  //Updates account store
  useEffect(() => {
    setIsAccountLoading(isAccountDataLoading);
  }, [isAccountDataLoading]);

  // Handle Fetching Account List
  useEffect(() => {
    const handleAccounts = async () => {
      if (isAccountsDataLoading || !isAdminMode) return;
      if (!accountsDataListError && accountsListData) {
        idToCompanyNameMap = accountsListData?.reduce(
          (acc, { id }: Account) => ({ ...acc, [id || '']: id || '' }),
          {} as Record<string, string>,
        );
        const companyOptions = Object.entries(idToCompanyNameMap);
        setCompanyNames(companyOptions);
      } else {
        console.error('Error fetching data');
      }
    };
    handleAccounts(); // Getting All The Accounts as Use Accounts
  }, [accountsListData]);

  //Sets If user is admin
  useEffect(() => {
    userData && setIsAdmin(userData?.isAdmin);
  }, [userData]);

  // State to hold the selected option (optional, depending on your use case)
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>('');
  const handleSelectAccountChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCompanyId(event.target.value);
    const currentAccount = accountsListData && accountsListData.find((x) => x.id === event.target.value);
    setAccount([currentAccount as Account, event.target.value]);
  };

  if (!isAdmin) return <></>;

  return (
    <div className="flex space-x-[1rem] mx-[1rem]">
      <ButtonDesigned
        className="hidden"
        style={isAdminMode ? 'primary' : 'outline'}
        onButtonClick={() => setIsAdminMode(!isAdminMode)}
      >
        {isAdminMode ? 'Admin mode' : 'User Mode'}
      </ButtonDesigned>
      {isAdminMode && (
        <select
          className="border rounded p-[0.2rem]"
          title="Company Selector"
          value={selectedCompanyId}
          onChange={handleSelectAccountChange}
        >
          {companyNames.map(([id, name]) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};
export default AccountSelector;
